import { AppClockComponent, DateTimeService, type } from '@mews/framework';

export default function AppDateComponent(
    appClockComponent: $TSFixMe,
    { getCurrentEnterpriseIanaTimeZoneIdentifier }: $TSFixMe
) {
    type.check(appClockComponent, AppClockComponent);

    return type.create(AppDateComponent, {
        /** @deprecated use getAppDateTimeNow or getCurrentEnterpriseAppDateTimeNow */
        now,

        /** @deprecated use getAppDateTimeNow and DateTimeService.startOfDay */
        today: () => DateTimeService.startOfDay(now()),
    });
    function now() {
        return DateTimeService.fromUtc(appClockComponent.getAppNowUtc(), getCurrentEnterpriseIanaTimeZoneIdentifier());
    }
}
